if (document.readyState !== 'loading') {
    initWidget();
} else {
    window.addEventListener('DOMContentLoaded', () => {
        initWidget();
    });
}

function initWidget() {
    const sliders = document.querySelectorAll('.ct_referencesslider:not(.admin_preview)');

    if (sliders) {
        sliders.forEach((sliderContainer) => {
            const navContainer = sliderContainer.querySelector('.slickNav');
            const slider = sliderContainer.querySelector('.slider');

            if (!slider) {
                return;
            }

            const generalOptions = {
                arrows: true,
                infinite: true,
                appendArrows: navContainer ?? slider,
                prevArrow: '<button class="btn slick-prev"><i class="fal fa-long-arrow-left"></i></button>',
                nextArrow: '<button class="btn slick-next"><i class="fal fa-long-arrow-right"></i></button>',
            };
            let addedOptions = {};

            // Add the options appropriate for the default slider
            if (sliderContainer.classList.contains('default')) {
                addedOptions = {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    responsive: [
                        {
                            breakpoint: 1920,
                            settings: {
                                slidesToShow: 3,
                            },
                        },
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 2,
                            },
                        },
                        {
                            breakpoint: 960,
                            settings: {
                                slidesToShow: 1,
                            },
                        },
                    ],
                };
            }

            const sliderOptions = { ...generalOptions, ...addedOptions };

            jQuery(slider).slick(sliderOptions);
        });
    }
}
